<template>
  <v-card flat color="transparent" class="d-flex pa-0 ma-0">
    <v-card-text class="d-flex pa-0 ma-0">
      <v-img
        v-if="!thumbnail"
        :src="profileImage"
        :lazy-src="defaultImage"
        max-width="160"
        max-height="160"
        class="rounded-circle"
      ></v-img>
      <v-avatar
        :class="classCss"
        :size="size"
        v-else-if="imageUrl"
        style="border: 1px solid #ebe7e7  !important;"
        class=" ms-2 mt-3"
      >
        <v-img :src="profileImage"></v-img>
      </v-avatar>

      <v-avatar
        :size="size"
        v-else
        :color="getColorFromName(displayName)"
        class="pb-1 white--text px-0 ms-2 mt-3"
        :class="classCss"
      >
        <div>{{ getShortName(displayName) }}</div>
      </v-avatar>

      <v-card-subtitle v-if="showName && displayName" class="px-2 pb-1  font-weight-bold">
        <span v-if="to" >
          <router-link :to="to" class=" text-body-2 ">
            {{ displayName }}
          </router-link>
        </span>
        <span v-else >
          {{ displayName }}
        </span>
        <div v-if="stageInfo" class="text-caption text-secondary">
          {{ stageInfo.stageName }}
        </div>
      </v-card-subtitle>
    </v-card-text>
  </v-card>
</template>

<script>
import { size } from "lodash";

export default {
  name: "ProfileImage",
  props: {
    imageUrl: {
      type: String,
      default: ""
    },
    displayName: {
      type: String,
      default: ""
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    showName: {
      type: Boolean,
      default: true
    },
    stageInfo: {
      type: Object,
      default: null
    },
    size: {
      type: Number,
      default: 42
    },
    classCss: {
      type: String,
      default: ""
    },
    to: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      defaultImage: require("@/assets/user.svg")
    };
  },
  computed: {
    profileImage() {
      var image = this.imageUrl || this.defaultImage;
      if (this.thumbnail) {
        return this.imageUrl;
      }
      return image;
    }
  }
};
</script>
